import { render } from "./CRMDatatableTDTaskType.vue?vue&type=template&id=400a17ac&scoped=true"
import script from "./CRMDatatableTDTaskType.vue?vue&type=script&lang=js"
export * from "./CRMDatatableTDTaskType.vue?vue&type=script&lang=js"

import "./CRMDatatableTDTaskType.vue?vue&type=style&index=0&id=400a17ac&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400a17ac"]])

export default __exports__